// Do not change this file
export const VERSION = '1.3.0';
export const IXLIB = 'video-' + VERSION;
